export default "__VITE_ASSET__C0zC7JRn__"